import { Component } from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {NbDatepickerModule, NbInputModule} from '@nebular/theme';
import {ReactiveFormsModule} from "@angular/forms";
import {NgIf} from '@angular/common';


@Component({
  selector: 'app-date-timepicker',
  standalone: true,
  imports: [
    NbDatepickerModule,
    ReactiveFormsModule,
    FormlyModule,
    NgIf,
    NbInputModule
  ],
  templateUrl: './date-timepicker.component.html'
})
export class DateTimePickerComponent extends FieldType {
  filterFn = (_date) => {
    return true;
  }
}
